import { render, staticRenderFns } from "./Move.vue?vue&type=template&id=65221c1e&scoped=true"
import script from "./Move.vue?vue&type=script&lang=js"
export * from "./Move.vue?vue&type=script&lang=js"
import style0 from "./Move.vue?vue&type=style&index=0&id=65221c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65221c1e",
  null
  
)

export default component.exports